export const skopjeGeolocation = Object.freeze({
  latitude: 41.99646,
  longitude: 21.43141,
});
